import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/LocationController/CreateLocationController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateLocation({ location, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ vc_Name: '', vc_Telephone: '', vc_Address1: '',int_Identity: '0' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (location) {
            setFormData({
                vc_Name: location.vc_Name, vc_Telephone: location.vc_Telephone, vc_Address1: location.vc_Address1,
                vc_Address2: location.vc_Address2, vc_County: location.vc_County, vc_Postcode: location.vc_Postcode, vc_Town: location.vc_Town,
                vc_Fax: location.vc_Fax, int_Identity: location.int_Identity
            });
        } else {
            setFormData({ vc_Name: '', vc_Telephone: '', vc_Address1: '', vc_Address2: '', vc_County: '', vc_Postcode: '', vc_Town: '', vc_Fax: '', int_Identity: '0' }); // Clear form data when switching to add mode
        }
    }, [location]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (location) {
            formData.ID = location.PK_Location_ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="locationModal" tabIndex="-1" aria-labelledby="locationModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{location ? "Edit Depot" : "Add Depot"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Name:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Name" value={formData.vc_Name} onChange={handleFieldChange} />
                                        {errors.vc_Name && <div style={{ color: 'red' }}>{errors.vc_Name}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Telephone:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Telephone" value={formData.vc_Telephone} onChange={handleFieldChange} />
                                        {errors.vc_Telephone && <div style={{ color: 'red' }}>{errors.vc_Telephone}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Address 1:</label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" name="vc_Address1" value={formData.vc_Address1} onChange={handleFieldChange} />
                                        {errors.vc_Address1 && <div style={{ color: 'red' }}>{errors.vc_Address1}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Address 2:</label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" name="vc_Address2" value={formData.vc_Address2} onChange={handleFieldChange} />

                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">County:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_County" value={formData.vc_County} onChange={handleFieldChange} />

                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Postcode:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Postcode" value={formData.vc_Postcode} onChange={handleFieldChange} />

                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Town /City:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Town" value={formData.vc_Town} onChange={handleFieldChange} />

                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Fax:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Fax" value={formData.vc_Fax} onChange={handleFieldChange} />

                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Identity:</label>
                                    <div className="col-sm-4">
                                        <input type="number" className="form-control" name="int_Identity" value={formData.int_Identity} onChange={handleFieldChange} />

                                    </div>


                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                <i className="icofont-save" aria-hidden="true"> {location ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateLocation;